var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncollapseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu expand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 5.44772 11.5523 5 11 5H3C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H11C11.5523 7 12 6.55228 12 6Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.0024H18.17L15.29 8.12242C14.9 7.73242 14.9 7.10242 15.29 6.71242C15.68 6.32242 16.31 6.32242 16.7 6.71242L21.29 11.3024C21.68 11.6924 21.68 12.3224 21.29 12.7124L16.7 17.3024C16.31 17.6924 15.68 17.6924 15.29 17.3024C14.9 16.9124 14.9 16.2824 15.29 15.8924L18.17 13.0024H3C2.45 13.0024 2 12.5524 2 12.0024C2 11.4524 2.45 11.0024 3 11.0024Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H11Z",
    fill: "#121212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncollapseIcon);
export default __webpack_public_path__ + "static/media/uncollapse-icon.2788098e7e6ef52fbf4861e5be5c203a.svg";
export { ForwardRef as ReactComponent };